export default {"src":"/_next/static/media/chevrons-left.4dde668a.svg","height":44,"width":44,"blurWidth":0,"blurHeight":0};